
export const daysRangeOptions = [
  { value: '1-3', label: '1-3 days per week' },
  { value: '3-5', label: '3-5 days per week' },
  { value: '5+', label: '5+ days per week' }
];

export const weekDaysOptions = [
  { value: 'mon', label: 'Monday' },
  { value: 'tue', label: 'Tuesday' },
  { value: 'wed', label: 'Wednesday' },
  { value: 'thu', label: 'Thursday' },
  { value: 'fri', label: 'Friday' },
  { value: 'sat', label: 'Saturday' },
  { value: 'sun', label: 'Sunday' }
];
